/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import BenefitsService from 'src/services/benefits.service';

export const useBenefitDeletePrice = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (params: { id: string; type: string }) => BenefitsService.deleteBenefitPrices({ ...params }),
    {
      onSuccess: () => {
        AlertAdapter('Price deleted successfully', 'success');
        queryClient.invalidateQueries(['benefits/prices']);
      },
      onError: () => {
        AlertAdapter('Failed to delete', 'error');
      },
    }
  );
  return mutation;
};
